"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_tabs_1 = require("react-tabs");
var controlList_1 = require("./controlList");
var actionList_1 = require("./actionList");
var React = require("react");
var utils_1 = require("../../utils");
var urls_1 = require("../../urls");
var App_1 = require("../../App");
var contexts_1 = require("../../interfaces/contexts");
var TabIndexes = (function () {
    function TabIndexes() {
    }
    TabIndexes.CONTROLS = 0;
    TabIndexes.ACTIONS = 1;
    return TabIndexes;
}());
var ControlActionList = (function (_super) {
    __extends(ControlActionList, _super);
    function ControlActionList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            tabIndex: TabIndexes.CONTROLS
        };
        _this.setTabIndex = function (tabIndex) {
            _this.setState({ tabIndex: tabIndex });
        };
        _this.clickControlsHandler = function (event) {
            (0, utils_1.preventDefault)(event);
            history.pushState(null, null, _this.getUrl(urls_1.Urls.control_list));
        };
        _this.clickActionsHandler = function (event) {
            (0, utils_1.preventDefault)(event);
            history.pushState(null, null, _this.getUrl(urls_1.Urls.action_list));
        };
        _this.getUrl = function (url, search) {
            if (search === void 0) { search = true; }
            var context = App_1.store.context.get();
            if (context instanceof contexts_1.ProjectContext) {
                var project_id = context.project;
                var location_1 = window.location.search;
                var params = new URLSearchParams(location_1);
                return (0, urls_1.resolve)(url, project_id) + (search ? ("?" + params.toString()) : "");
            }
            else {
                throw new Error("ControlActionList does not support the current context");
            }
        };
        _this.actionsOrControls = function () {
            var controls_url = _this.getUrl(urls_1.Urls.control_list, false);
            var actions_url = _this.getUrl(urls_1.Urls.action_list, false);
            switch (window.location.pathname) {
                case controls_url:
                    return TabIndexes.CONTROLS;
                case actions_url:
                    return TabIndexes.ACTIONS;
                default:
                    return TabIndexes.CONTROLS;
            }
        };
        return _this;
    }
    ControlActionList.prototype.componentDidMount = function () {
        this.setTabIndex(this.actionsOrControls());
    };
    ControlActionList.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_tabs_1.Tabs, { selectedTabClassName: "active", selectedIndex: this.state.tabIndex, onSelect: function (tabIndex) { return _this.setTabIndex(tabIndex); } },
            React.createElement(react_tabs_1.TabList, { className: "nav nav-tabs control_list_tabs" },
                React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                    React.createElement("a", { className: "nav-link", onClick: this.clickControlsHandler, href: this.getUrl(urls_1.Urls.control_list) }, gettext("Controls"))),
                React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                    React.createElement("a", { className: "nav-link", onClick: this.clickActionsHandler, href: this.getUrl(urls_1.Urls.action_list) }, gettext("Actions")))),
            React.createElement(react_tabs_1.TabPanel, null,
                React.createElement(controlList_1.default, null)),
            React.createElement(react_tabs_1.TabPanel, null,
                React.createElement(actionList_1.default, null))));
    };
    return ControlActionList;
}(React.Component));
exports.default = ControlActionList;
